import React, { useState, useEffect } from 'react';
import Page from 'src/components/Page';
import {
  Alert,
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  IconButton,
  List,
  ListItem,
  Modal,
  Pagination,
  PaginationItem,
  Paper,
  Radio,
  RadioGroup,
  Snackbar,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Iconify from 'src/components/Iconify';
import { Link, json, useLocation, useNavigate } from 'react-router-dom';
import { Table } from '@material-ui/core';
import { api } from 'src/Api';
import AddDocumentModal from 'src/components/home/AddDocumentModal';
import DeleteIcon from '@mui/icons-material/Delete';

export default function HistoryDoc() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('token');
  const { docid } = location.state || {};

  const [loading, setloading] = useState(false);

  const [file, setFile] = useState([]);
  const [error, seterror] = useState('');

  useEffect(() => {
    handleListDoc();
  }, [token]);

  const handleListDoc = () => {
    setFile([]);
    setloading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const params = new URLSearchParams();
    params.append('customer_service_id', docid);

    const url = `${api.get_service_document}?${params.toString()}`;

    const requestOptions = {
      headers: myHeaders,
      method: 'GET',
      redirect: 'follow'
    };

    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setFile(result?.data);
        } else {
          console.log('error doclist', result.message);
          seterror(result.message);
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setloading(false);
      });
  };

  return (
    <Page title={`Document | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack alignItems={'center'}>
            <Stack direction="row">
              <IconButton
                style={{
                  marginRight: 12,
                  height: 40,
                  width: 70,
                  borderRadius: 5,
                  backgroundColor: 'rgba(249, 0, 1,0.1)'
                }}
                onClick={() => navigate(-1)}
              >
                <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#f90001' }} />
              </IconButton>

              <div style={{ width: '100%' }}>
                <Typography variant="h4" sx={{ color: '#f90001' }}>
                  Document
                </Typography>
              </div>
            </Stack>
          </Stack>
        </Stack>

        <Box mt={2}>
          <Card>
            {file && !loading && (
              <List>
                {file.map((doc, index) => (
                  <>
                    <Box p={1}>
                      <ListItem
                        style={{
                          height: 70,
                          backgroundColor: 'rgba(0,0,0,0.05)',
                          borderRadius: 5,
                          marginTop: 10
                        }}
                        key={index}
                        secondaryAction={
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'flex-end'
                            }}
                          >
                            <div
                              style={{
                                height: 30
                              }}
                            ></div>
                            <p style={{ fontSize: 11, color: 'black' }}>{doc?.created_at}</p>
                          </Box>
                        }
                      >
                        <div>
                          <Link
                            to={doc?.url}
                            target="blank"
                            style={{ fontSize: 13, color: 'black' }}
                          >
                            {doc?.file_name}
                          </Link>
                          <p style={{ fontSize: 13, fontWeight: '500', color: '#f90001' }}>
                            Uploaded by: {doc?.uploaded_by}
                          </p>

                          <p style={{ fontSize: 13, fontWeight: '500', color: '#f90001' }}>
                            Step Name: {doc?.step || '-'}
                          </p>
                        </div>
                      </ListItem>
                    </Box>
                  </>
                ))}
              </List>
            )}
            {/* loader */}
            {loading && (
              <Box
                sx={{
                  height: '40vh',
                  flex: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <CircularProgress />
              </Box>
            )}

            {file?.length == 0 && !loading && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '40vh'
                }}
              >
                <Typography color={'#ccc'}>{error}</Typography>
              </Box>
            )}
          </Card>
        </Box>
      </Container>
    </Page>
  );
}
